import { signInWithCustomToken } from "firebase/auth";
import { firebaseAuth } from "services/firebaseService/firebaseConfig";

const signInWithToken = async (token: string) =>
  signInWithCustomToken(firebaseAuth, token);

export default signInWithToken;
